import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';
interface UnattachDocumentRequest {
  id: number;
  attachId: number;
}

const useUnattachDocumentsApi = (isInvoice: boolean) => {
  const call = useCallback(
    (params?: UnattachDocumentRequest) =>
      axiosInstance
        .put(
          isInvoice
            ? api.unAttachInvoiceUrlFn(params?.id as number, params?.attachId as number)
            : api.unAttachReceiptUrlFn(params?.id as number, params?.attachId as number)
        )
        .catch((error) => {
          throw new Error(error);
        }),
    [isInvoice]
  );
  const { execute, isLoading } = useAsync(call, false);

  return { unAttachDocument: execute, isLoading };
};

export default useUnattachDocumentsApi;
